import React from 'react';
import PropTypes from 'prop-types';

export default function SearchButton({
  children, onClick, disabled, id, icon: Icon,
}) {
  const baseStyle = "inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2";
  const enabledStyle = "bg-indigo-500 hover:bg-indigo-600 focus:ring-indigo-500";
  const disabledStyle = "bg-gray-400 cursor-not-allowed";

  return (
    <button
      id={id}
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyle} ${disabled ? disabledStyle : enabledStyle}`}
    >
      {Icon && <Icon className="h-5 w-5 mr-2" />}
      {children}
    </button>
  );
}

SearchButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
};

SearchButton.defaultProps = {
  disabled: false,
  icon: null,
};
